import _Cart from './Cart'

export const Cart = _Cart

export default { Cart }
